define('ShareCart.Cart.View', [
    'sharecart_cart.tpl',
    'ShareCart.Cart.Line',
    'Profile.Model',
    'Backbone.CollectionView',
    'Backbone',
    'jQuery',
    'underscore',
    'Utils'
], function ShareCartCartView(
    sharecartCartTpl,
    ShareCartCartLine,
    ProfileModel,
    BackboneCollectionView,
    Backbone,
    jQuery,
    _,
    Utils
) {
    'use strict';

    return Backbone.View.extend({
        template: sharecartCartTpl,
        initialize: function initialize(options) {
            this.application = options.container;
            this.cart = options.cart;
            this.model = options.model;

            this.listenTo(this.model, 'sync', this.render);
        },
        events: {
            'click [data-action="add-all-to-cart"]': 'addAllToCart',
            'click [data-action="add-this-to-cart"]': 'addThisToCart'
        },
        addAllToCart: function addAllToCart() {
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var items = (this.model && this.model.get('items')) ? this.model.get('items') : {};
            var item;
            var options;
            var storeOption;
            var isPurchasable;
            var lineData;
            var itemsForCart = items.map(function map(line) {
                lineData = {};
                item = line.get('item');
                options = line.get('options').toJSON();
                options = _.reject(options, function reject(option) {
                    return !option.value;
                });
                if (store && store.get('internalid')) {
                    storeOption = _.findWhere(options, {
                        cartOptionId: 'custcol_sca_store_id'
                    });
                    _.extend(storeOption, {
                        value: {
                            internalid: store.get('internalid'),
                            label: store.get('internalid')
                        }
                    });
                }
                isPurchasable = item.get('_isPurchasable');
                if (isPurchasable) {
                    lineData.quantity = line.get('quantity');
                    lineData.item = {
                        internalid: item.get('internalid')
                    };
                    lineData.options = options;
                }
                return lineData;
            });
            itemsForCart = _.reject(itemsForCart, function reject(line) {
                return !line.item;
            });
            this.addToCart(itemsForCart);
        },
        addThisToCart: function addThisToCart(e) {
            var itemId = jQuery(e.currentTarget).data('itemid');
            var item;
            var itemInternalId;
            var itemForCart;
            var options;
            var isPurchasable;
            var findLine = _.find(this.model.get('items').models, function find(line) {
                item = line.get('item');
                itemInternalId = item.get('internalid');
                return itemId === itemInternalId;
            });
            if (findLine) {
                item = findLine.get('item');
                options = findLine.get('options').toJSON();
                options = _.reject(options, function reject(option) {
                    return !option.value;
                });
                isPurchasable = item.get('_isPurchasable');
                if (isPurchasable) {
                    itemForCart = {
                        quantity: findLine.get('quantity'),
                        item: {
                            internalid: item.get('internalid')
                        },
                        options: options
                    };
                    this.addToCart([itemForCart]);
                }
            }
        },
        addToCart: function addToCart(items) {
            var self = this;
            var messagePrefix = (items.length > 1) ? 'items were' : 'item was';
            var messageText = 'added to your cart';
            if (items && items.length) {
                this.cart.addLines({
                    lines: items
                }).done(function done() {
                    self.cart.showMessage({
                        message: Utils.translate('$(0) ' + messagePrefix + ' ' + messageText, items.length),
                        type: 'success',
                        selector: 'Notifications',
                        timeout: 10000
                    });
                });
            }
        },
        childViews: {
            'ShareCart.Cart.Lines': function ShareCartCartLines() {
                var items = (this.model && this.model.get('items')) ? this.model.get('items') : {};
                var models = (items && items.models) ? items.models : [];
                return new BackboneCollectionView({
                    childView: ShareCartCartLine,
                    viewsPerRow: 1,
                    collection: new Backbone.Collection(models)
                });
            }
        },
        getContext: function getContext() {
            var items = (this.model && this.model.get('items')) ? this.model.get('items') : {};
            var canAddAllToCart;
            if (items && items.length) {
                canAddAllToCart = items.find(function find(line) {
                    return line.get('item').get('_isPurchasable') === true;
                });
            }
            return {
                canAddAllToCart: canAddAllToCart,
                showSharedCart: (items && items.length)
            };
        }
    });
});
